import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import ResetPassword from "@/pages/ResetPassword";

export const Route = createFileRoute("/reset-password")({
  head: () => seoHead("/reset-password"),
  component: ResetPassword,
});
